export default {
  en: {
    id: 'exercise6',
    subtitle: 'SUGGESTED STRUCTURE<br/>EXECUTIVE SUMMARY CASCADE GROUP',
    blocks: [
      {
        task: `ISG is planning to enter the external SEI&M market`,
        title: "S = ",
        answer: ' ',
        note: '',
        disableEdit: true
      },
      {
        task: `Highly competitive, need strategy to be successful.`,
        title: "C = ",
        answer: ' ',
        note: 'Sol, R2',
        disableEdit: true
      },
      {
        task: '(What should the strategy be?)',
        title: "Q = ",
        answer: ' ',
        disableEdit: true
      }
    ],
    withoutAnswers: true,
    hideTaskTitle: true,
    submitButton: 'switch'
  },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise6.js